import aboutHTMLURL from '../views/administration/about/about.html';
import settings from '../views/administration/portal/settings/settings.html';

import { settingsStateName } from 'fides-angularjs-components/src/fts-administration/fts-regional-settings';
import { passwordStateName } from 'fides-angularjs-components/src/fts-administration/fts-change-password';
import {
    exportDownloadSettingsStateName
} from 'fides-angularjs-components/src/fts-administration/fts-exportDownload-settings';
import {
    downloadSettingsStateName
} from 'fides-angularjs-components/src/fts-administration/fts-exportDownload-settings/fts-download-settings';

import { ReportingRouterStates } from './reporting.route';
import { AdministrationAccountsRouterStates } from './administrationAccounts.route';
import { AccountGroupsRouterStates } from './accountGroups.route';
import { UserReportsRouterStates } from "./userReports.route";

export class AdministrationRouterStates {
    /** @ngInject */
    constructor($stateProvider) {
        this.$stateProvider = $stateProvider;
    }

    defineStates() {
        this.$stateProvider.state('administration', {
            url: '',
            abstract: true
        }).state('app.about', {
            url: '/about',
            templateUrl: aboutHTMLURL,
            params: {
                pageTitle: 'ABOUT'
            }
        }).state(settingsStateName, {
            url: '/settings',
            templateUrl: settings,
            controller: 'CommonViewController',
            controllerAs: 'vm',
            params: {
                pageTitle: 'CLIENT_SETTINGS'
            }
        }).state(passwordStateName, {
            url: '/password',
            templateUrl: settings,
            controller: 'CommonViewController',
            controllerAs: 'vm',
            params: {
                pageTitle: 'CHANGE_PASSWORD'
            }
        }).state(exportDownloadSettingsStateName, {
            url: '/exportDownloadSettings',
            templateUrl: settings,
            controller: 'CommonViewController',
            controllerAs: 'vm',
            params: {
                pageTitle: 'EXPORTDOWNLOAD_SETTINGS'
            }
        }).state(downloadSettingsStateName, {
            url: '/downloadSettings',
            templateUrl: settings,
            controller: 'CommonViewController',
            controllerAs: 'vm',
            params: {
                pageTitle: 'DOWNLOAD_SETTINGS'
            }
        });

        new AccountGroupsRouterStates(this.$stateProvider).defineStates();
        new ReportingRouterStates(this.$stateProvider).defineStates();
        new AdministrationAccountsRouterStates(this.$stateProvider).defineStates();
        new UserReportsRouterStates(this.$stateProvider).defineStates();
    }
}
